import httpClientlikes from "./httpLikesClient";
export const onLikesApiCall = async ({
  method,
  url,
  data,
  params,
  isFileUpload = false,
  isPdf = false,
}) => {
  // const { resetClick } = useContext(Appcontext);

  const constructHeaders = () => {
    if (isFileUpload) {
      return {
        common: { "Content-Type": "multipart/form-data" },
      };
    } else if (isPdf) {
      return {
        common: { "Content-Type": "application/pdf" },
      };
    } else {
      return {
        common: { "Content-Type": "application/json" },
      };
    }
  };

  try {
    const response = await httpClientlikes.request({
      url,
      method,
      data,
      params,
      headers: constructHeaders(),
    });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    if (error.response) {
      console.log("API Error Response:", error.response);
      return {
        data: error.response.data.error ?? error.response.data,
        status: error.response.status,
      };
    } else if (error.request) {
      return {
        data: "api error",
      };
    } else {
      return {
        data: "api error",
      };
    }
  }
};
